import React from 'react';
import Slider from 'nuka-carousel';
import cn from 'classnames';
import defer from 'lodash.defer';
import styles from './Carousel.css';
import navStyles from './NavStyles.css';
import { preventEvent } from './util';

const renderBottomRightControls = ({
    previousSlide,
    nextSlide,
    slideCount,
    currentSlide
}) => (
    <nav>
        <a
            href="#prev"
            className={cn('prev', { disabled: !currentSlide })}
            onClick={preventEvent(previousSlide)}
        >
            Previous
        </a>
        <span>
            {currentSlide + 1}/{slideCount}
        </span>
        <a
            href="#next"
            className={cn('next', { disabled: currentSlide + 2 > slideCount })}
            onClick={preventEvent(nextSlide)}
        >
            Next
        </a>
        <style jsx>{navStyles}</style>
    </nav>
);

const no = () => {};

const settings = {
    renderBottomCenterControls: no,
    renderBottomRightControls,
    renderCenterLeftControls: no,
    renderCenterRightControls: no
};

const Carousel = ({ children }) => {
    let slider;
    // @note:
    // fixes height miscalculation
    defer(() => slider && slider.onResize());
    return (
        <div className="slider">
            <Slider
                {...settings}
                ref={(s) => {
                    slider = s;
                }}
            >
                {children}
            </Slider>
            <style jsx>{styles}</style>
        </div>
    );
};

export default Carousel;
